import { cmtsCurrentCacheAllowList, isCmtsAppOwnedCacheName } from "./cmtsPwaVersion.js";

export type CmtsCacheCleanupResult = {
  readonly ok: boolean;
  readonly deletedCaches: string[];
  readonly preservedCaches: string[];
  readonly skippedReason?: string | undefined;
  readonly errorMessage?: string | undefined;
};

type CacheLike = Pick<CacheStorage, "keys" | "delete">;

function getCacheStorage(): CacheLike | undefined {
  const value = globalThis as typeof globalThis & { caches?: CacheStorage | undefined };
  return value.caches;
}

export async function cleanupCmtsAppOwnedCaches(options: { readonly currentCacheNames?: readonly string[] | undefined; readonly cachesApi?: CacheLike | undefined } = {}): Promise<CmtsCacheCleanupResult> {
  const cachesApi = options.cachesApi ?? getCacheStorage();
  if (!cachesApi) {
    return { ok: true, deletedCaches: [], preservedCaches: [], skippedReason: "Cache API unavailable in this runtime." };
  }
  try {
    const keep = new Set(options.currentCacheNames ?? cmtsCurrentCacheAllowList);
    const keys = await cachesApi.keys();
    const deletedCaches: string[] = [];
    const preservedCaches: string[] = [];
    for (const key of keys) {
      if (!isCmtsAppOwnedCacheName(key) || keep.has(key)) {
        preservedCaches.push(key);
        continue;
      }
      const deleted = await cachesApi.delete(key);
      if (deleted) deletedCaches.push(key);
      else preservedCaches.push(key);
    }
    return { ok: true, deletedCaches, preservedCaches };
  } catch (error: unknown) {
    return {
      ok: false,
      deletedCaches: [],
      preservedCaches: [],
      errorMessage: error instanceof Error && error.message.trim() ? error.message : "CMTS cache cleanup failed.",
    };
  }
}
